import api from "./api";
import { CreateCamiseta, ICamiseta } from "interfaces/kitsCamiseta";

export async function getTamanhoCamisetaDefault(
  idEvento: number
): Promise<CreateCamiseta[]> {
  try {
    const response = await api.get("/camisetasdefault");
    // Criar um novo array sem modificar o original
    const withTamanhoCamiseta: CreateCamiseta[] = response.data.map(
      (camiseta: ICamiseta) => ({
        ...camiseta,
        eventId: idEvento,
      })
    );

    return withTamanhoCamiseta;
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || "Falha na comunicação com o servidor"
    );
  }
}

export async function createTamanhoCamiseta(kits: CreateCamiseta[]) {
  try {
    const respose = await api.post("/evento/camisetas", kits);
    if (respose.status === 201) return respose.data;
    else throw new Error("Falha ao criar o lote");
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || "Falha na comunicação com o servidor"
    );
  }
}

export async function editTamanhoCamiseta(kits: CreateCamiseta) {
  try {
    const response = await api.put("/evento/camisetas", kits);
    if (response.status === 200) return response.data;
    else throw new Error("Falha ao criar o lote");
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || "Falha na comunicação com o servidor"
    );
  }
}

export async function deleteTamanhoCamiseta(id: number) {
  try {
    const respose = await api.delete(`/evento/camisetas/${id}`);
    if (respose.status === 200) return respose.data;
    else throw new Error("Falha ao criar o lote");
  } catch (error: any) {
    throw new Error(
      error?.response?.data?.message || "Falha na comunicação com o servidor"
    );
  }
}
